import { OrderService } from './../services/order.service';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Http } from '@angular/http';
import { JsonSchemaFormService } from 'angular4-json-schema-form-updated';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import { environment } from '../../../environments/environment';
import { ContactTypeConstants } from '../../common/constants/contact-type.constants';
import { SchemaProperty } from '../enums/schema-property.enum';
import { MessageService } from '../../shared/services/message.service';
import { ConfigurationService } from '../services/configuration.service';
import { Subscription } from 'rxjs';
import { VatPayerOptions } from '../../common/constants/vatpayer-options.constants';
import { AccountTypeConstants } from '../../common/constants/account-type-constants';
import { PayTypeConstants, PayTypeConstantsZAF } from '../../common/constants/pay-type-constants';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from './../../shared/services/cache.service';
import { AddressService } from './../services/address.service';
import { CacheKey } from './../../shared/constants/cachekey.constants';
import { CheckoutConfig } from '../interface/checkout-config.interface';
import { CheckoutConfigService } from '../services/checkout-config.service';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'custom-select-widget',
  template: `  <!-- [class]="options?.htmlClass || ''"-->
  <div [class.floatLabelContainer]="true">
  <label *ngIf="options?.title"
    [attr.for]="'control' + layoutNode?._id"
    [class]="options?.labelHtmlClass"
    [style.display]="options?.notitle ? 'none' : ''"
    [innerHTML]="options?.title"></label>
  <select float-label [attr.data-placeholder]="options?.selectText"
    [formControl]="formControl"
    [attr.aria-describedby]="'control' + layoutNode?._id + 'Status'"
    [attr.readonly]="options?.readonly ? 'readonly' : null"
    [attr.required]="options?.required"
    [class]="options?.fieldHtmlClass"
    [attr.disabled]="controlDisabled ? true : null"
    [id]="'control' + layoutNode?._id"
    [name]="controlName"
    (change)="updateValue($event)">
    <option *ngFor="let selectItem of list"
       [value]="selectItem.value"
       [disabled]="selectItem && selectItem?.flag"
       [selected]="selectItem.value === controlValue">{{selectItem.name}}</option>
  </select>
  </div>
  <div class="hide-widget" *ngIf="hideWidget">
    <label class="label-class">{{options?.selectText}}</label>
    <div>NA</div>
  </div>`,
})
export class CustomSelectWidgetComponent implements OnInit, OnDestroy {
  formControl: AbstractControl;
  controlName: string;
  controlValue: any;
  controlDisabled = false;
  boundControl = false;
  options: any;
  list: any[] = [];
  data: any[];
  optionsGetUrl: any;
  hideWidget = false;
  cityList: any = [];
  @Input() formID: number;
  @Input() layoutNode: any;
  @Input() layoutIndex: number[];
  @Input() dataIndex: number[];
  checkoutConfig:CheckoutConfig;
  countryCode: string;
  cityListBasedOnStates: any[] = [];
  cityListBasedOnState: any[] = [];

  constructor(private jsf: JsonSchemaFormService, private _http: Http,
    private chRef: ChangeDetectorRef,
    private _messageService: MessageService,
    private _configurationService: ConfigurationService,
    private _translatePipe: TranslateService,
    private _cacheService: CacheService,
    private _addressService: AddressService,
    private _checkoutConfigService: CheckoutConfigService,
    private _orderService:OrderService ) {
  }

  ngOnInit() {
    this.options = this.layoutNode.options || {};
    this.countryCode = this._cacheService.get(CacheKey.COUNTRY_CODE);
    if(this.countryCode){
      this.checkoutConfig= this._checkoutConfigService.getSettings(this.countryCode,null);
      if(this.checkoutConfig.displayCityBasedOnState){
        const cities = this._cacheService.get(CacheKey.Cities)
        if(cities && cities.length>0){
          this.cityList = cities
        }
        else{
          this.getCitiesByStates();
        }
      }
    }
    if (this.options) {
      this.jsf.initializeControl(this);
      if (this.layoutNode.name === SchemaProperty.PHONETYPE) {
        this.getContactTypes();
      } else if (this.layoutNode.name === SchemaProperty.TITLE) {
        // this.getTitles();
      } else if (this.layoutNode.name === SchemaProperty.NEWSLETTERLANGUAGE) {
        this.optionsGetUrl = environment.apiUrl + this.options.optionGetUrl + this._configurationService.getEnrollCountry();
        this.getServiceData();
      } else if(this.layoutNode.name === SchemaProperty.VATPAYER){
            this.getvatPayerOptions();
      }
      else if (this.layoutNode.name === SchemaProperty.ACCOUNTTYPE) {
        this.getPayTypeZAF();
      }
      else if (this.layoutNode.name === SchemaProperty.PAYTYPE) {
        const isoCountryCode = this._configurationService.getEnrollCountry();
        console.log(isoCountryCode);
        
        if (isoCountryCode.toUpperCase() === "ZAF") {
          this.getPayTypeZAF();
        }
        else {
          this.getPayType();
        }

      }
      else if(this.layoutNode.name === SchemaProperty.CITY && this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState ){
        const address = this.jsf.formGroup.value.state;
        this.cityListBasedOnState =[];
        this.cityList.forEach((city: any) => { 
          if (this.jsf.formGroup.value.city && city.cityName.toLowerCase() === this.jsf.formGroup.value.city.toLowerCase()) {
            this.cityListBasedOnState.push(city);
          }
        });
        let isCityPresent;
        if (this.cityListBasedOnState) {
          this.cityListBasedOnState.forEach((city: any) => {
            if (city.stateCode === this.jsf.formGroup.value.state) {
              isCityPresent = true;
            }
          });
        }
        if (!isCityPresent) {
          this.jsf.formGroup.controls.city.setValue('');
          this.jsf.formGroup.controls.state.setValue('');
        }
        if(address){
            this._messageService.setCities(address);
        }
        this._messageService.getCities().subscribe((response:any)=>{
          this.list.splice(0, this.list.length);
          this.cityListBasedOnStates =[];
          this.cityList.forEach((city:any)=> {
            if(city.stateCode === response){
                this.cityListBasedOnStates.push(city);
            }});
          this.populateSelectBoxValues(this.cityListBasedOnStates);
          })
        if(this.jsf.formGroup.value.city){
          let response = this._cacheService.get(CacheKey.Cities);
          this.cityListBasedOnStates = [];
          response.forEach((city:any)=> {
            if(city.stateCode === this.jsf.formGroup.value.state){
                this.cityListBasedOnStates.push(city);
            }});
          // this.jsf.formGroup.controls.city.setValue('');
          this.populateSelectBoxValues(this.cityListBasedOnStates)
        }
      }
      else {
        this.optionsGetUrl = environment.apiUrl + this.options.optionGetUrl;
        this.getServiceData();
      }
    }
  }

    /* To get account type */
    getAccountType(): void {
      this.list = AccountTypeConstants.accountTypes;
      this.controlValue = this.options.default;
      this.jsf.initializeControl(this);
      if (!this.chRef['destroyed']) {
        this.chRef.detectChanges();
      }
    }
     /* To get pay type */
  getPayType(): void {
    PayTypeConstants.payTypes.forEach(type => {
      let payType = this._translatePipe.instant(type.name);
      this.list.push({ 'name': payType, 'value': type.value });
    })
  }

  getPayTypeZAF(): void {
    const selectText = this.options.selectText;
    const defaultOpt = {
      name: selectText || 'Select',
      value: null
    };
    PayTypeConstantsZAF.payTypesZAF.forEach((pay: any) => {
      this.list.push(pay);
    });
    this.list.splice(0, 0, defaultOpt);
    this.jsf.initializeControl(this);
    if (!this.chRef['destroyed']) {
      this.chRef.detectChanges();
    }
  }

  
  /**
   * This method used for getting contact types for phone number
   * getContactTypes
   */
  getContactTypes(): void {
    console.log(this.jsf.schema.properties.addressLine1)
  if(this.checkoutConfig && !this.checkoutConfig.removeMobileField){
        this.list = ContactTypeConstants.phoneTypes;
      }else if(this.checkoutConfig && this.checkoutConfig.removeMobileField){
        this.list[0] = ContactTypeConstants.phoneTypes[0];
        this.jsf.updateValue(this, this.list[0].value);
        this.controlDisabled = true;
      }else if (this.checkoutConfig && this.checkoutConfig.removePhoneField){
        this.list[0] = ContactTypeConstants.phoneTypes[1];
       this.jsf.updateValue(this, this.list[0].value);
       this.controlDisabled = true;
      }else{
        this.list = ContactTypeConstants.phoneTypes;
      }
  }

  getvatPayerOptions(): void {
    this.list = VatPayerOptions.vatPayer;
  }
  /**
   * @param  {any} event
   */
  updateValue(event: any) {
    if (this.controlName.toLowerCase() === 'country') {
      this._messageService.setCustomSelect(event.target.value);
    }
    if(this.controlName ===SchemaProperty.BANKCODE){
      this._messageService.setBankTypeChange(event.target.value);
    }
    const shippingForm = this.options.shippingSchemaForm;
    if(this.controlName === SchemaProperty.STATE  && this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState && shippingForm){
      this.jsf.formGroup.controls.city.setValue('');
      this._messageService.setCities(event.target.value);
    }
    this.jsf.updateValue(this, event.target.value);
    this.poboxValidation();
    this.postalCodeValidation();
  }

 /**
  * @description To Trigger POBOX Validation
  * @author njagadeesan
  * @date 2020-01-02
  * @memberof CustomSelectWidgetComponent
  */
 poboxValidation(): void {
  if (this.controlName === SchemaProperty.STATE) {
    const schemaProperties = this.jsf.schema.properties;
    Object.keys(schemaProperties).forEach((propertyName) => {
      if (schemaProperties[propertyName].poBoxValidation && this.formControl.parent) {
        this.formControl.parent.controls[propertyName].updateValueAndValidity({onlySelf: false, emitEvent: false});
      }
    });
  }
}

/**
 * @description
 * @date 2020-05-02
 * @memberof CustomSelectWidgetComponent
 */
postalCodeValidation(): void {
  if (this.controlName === SchemaProperty.COUNTRY || this.controlName === SchemaProperty.ZIP) {
    const schemaProperties = this.jsf.schema.properties;
    Object.keys(schemaProperties).forEach((propertyName) => {
      if (schemaProperties[propertyName].postalCodeValidation && this.formControl.parent) {
        this.formControl.parent.controls[propertyName].updateValueAndValidity({onlySelf: false, emitEvent: false});
      }
    });
  }
}


  /**
   * @returns Observable
   */
  getApiResponse(): Observable<any> {
    if (this.optionsGetUrl.includes('/bank-details')) {
      return this._orderService.getBonusBankDetails(this.optionsGetUrl);
    } else {
      return this._http
        .get(this.optionsGetUrl)
        .map((response: any) => response.json());
    }
  }

  /**
   * @returns void
   */
  getServiceData(): void {
    if (this.optionsGetUrl) {
      if (this.optionsGetUrl.indexOf('/states?countryID=') > 0 || this.optionsGetUrl.indexOf('/countries') > 0) {
        const countryID = this.getParameterByName('countryID', this.optionsGetUrl);
        // if (countryID) {
        //   stateOrCountries = this._cacheService.get(CacheKey.StatesByCountryId + '_' + countryID);
        // } else {
        //   stateOrCountries = this._cacheService.get(CacheKey.Countries);
        // }
        if (this.optionsGetUrl.indexOf('/states?countryID=') > 0 && countryID) {
          this.getSelectApiResponse();
        } else {
          this.getSelectApiResponse();
        }
      } else {
        this.getSelectApiResponse();
      }
    }
  }

  /**
   * @returns void
   */
  private getSelectApiResponse(): void {
    this.getApiResponse()
      .subscribe((response: any[]) => {
        this.populateSelectBoxValues(response);
      },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
          } else {
          }
        });
  }

  /**
   * @param  {string} name
   * @param  {string} url
   * @returns string
   */
  private getParameterByName(name: string, url: string): string {
    const match = RegExp('[?&]' + name + '=([^&]*)').exec(url);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  /**
   * @param  {any[]} response
   * @returns void
   */
  private populateSelectBoxValues(response: any[]): void {
    if (response) {
        this.data = response;
      if (this.data.length > 0) {
        let selectText = '';
        if (this.options.selectText && this.options.selectText.endsWith('*')) {
          selectText = this.options.selectText.slice(0, -1);
        } else {
          selectText = this.options.selectText;
        }
        const defaultOpt = {
          name: selectText || 'Select',
          value: '',
          // Added the flag for default select titles.
          flag: this.options.disabled ? this.options.disabled : true
        };
        const schema = this.jsf.schema.properties['' + this.controlName];
        let defaultValue = null;
        if (this.options && this.options.nameField && this.options.valueField) {
          const nameField = this.options.nameField;
          const valueField = this.options.valueField;
          const ctx = this;
          // JSON.stringify(ctx.prepareListMap(x))
          const selectOptions = this.data.map(function (x) {
            return {
              name: x[nameField], value: x[valueField]
            };
          });
          if (this.options.default && this.options.filterField) {
            const preLoadValue = this.controlValue ? (isNaN(Number(this.controlValue)) ? this.controlValue : Number(this.controlValue)) : this.options.default;
            const defaultObj = this.data.find(x => x['' + this.options.filterField] === preLoadValue);
            if (defaultObj) {
              defaultValue = defaultObj[this.options.filterField];
              this.controlValue = defaultValue;
            }
          }
          this.list = this.list.concat(selectOptions);
        } else {
          this.list = this.data;
        }
        if (!this.options.hideDefaultOption) {
          this.list.splice(0, 0, defaultOpt);
        }
        this.postalCodeValidation();
        this.jsf.initializeControl(this);
        if (!this.chRef['destroyed']) {
          this.chRef.detectChanges();
        }
        if (this.options.default && this.options.filterField) {
          this.controlValue = defaultValue;
          if (!this.chRef['destroyed']) {
            this.chRef.detectChanges();
          }
        }
      }
    }
  }

  private prepareListMap(obj: any): any {
    const schema = this.jsf.schema.properties['' + this.controlName];
    const mapObj = {};
    Object.keys(schema.properties).forEach((x: any) => {
      mapObj['' + x] = obj['' + x];
    });
    return mapObj;
  }

  ngOnDestroy() {
    this.chRef.detach();
  }

  getCitiesByStates() {
    const countryId = this._cacheService.get(CacheKey.COUNTRY_ID);
    this._addressService.getCitiesList(countryId).subscribe((response: any) => {
      if (response) {
        this.cityList = response;
        this._cacheService.set(CacheKey.Cities, response)
      }
    }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/widgets/custom-select.widget.ts